import React from 'react';import ReactDOM from 'react-dom';import { useNavigate } from 'react-router-dom';import styles from '../css-isolated/sa_homepage.module.css';import API_BASE_URL from '../config';import SaAdduser from './sa_adduser';import SaResetUserPassword from './sa_edituser'; // Updated import pathimport SaAddCell from './sa_add_cell';import SaEditCell from './sa_edit_cell';import SaAuditLogin from './sa_auditlogin';import ChangePasswordModal from './change_pass';
import authFetch from '../utils/authFetch';

function SaHomepage() {
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = React.useState(new Date());
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [userData, setUserData] = React.useState(null);
  const [currentView, setCurrentView] = React.useState(() => {
    try {
      return localStorage.getItem('sa_current_view') || 'auditlogs';
    } catch (e) {
      return 'auditlogs';
    }
  }); // Persisted current view with fallback
  const [isDarkMode, setIsDarkMode] = React.useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });
  const [showThemeModal, setShowThemeModal] = React.useState(false);
  const [pendingTheme, setPendingTheme] = React.useState(null);
  const [showLogoutModal, setShowLogoutModal] = React.useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState('');
  const [errorModalMessage, setErrorModalMessage] = React.useState('');
  const [showCellSuccessModal, setShowCellSuccessModal] = React.useState(false);
  const [showCellErrorModal, setShowCellErrorModal] = React.useState(false);
  const [cellSuccessMessage, setCellSuccessMessage] = React.useState('');
  const [cellErrorMessage, setCellErrorMessage] = React.useState('');

  // Check authentication on mount
  React.useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      navigate('/login-admin', { replace: true });
      return;
    }
    try {
      const parsedUser = JSON.parse(storedUser);
      setUserData(parsedUser);
    } catch (error) {
      console.error('Error parsing user data:', error);
      navigate('/login-admin', { replace: true });
    }
  }, [navigate]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleDarkMode = (newMode) => {
    setPendingTheme(newMode);
    setShowThemeModal(true);
  };

  const confirmThemeChange = async () => {
    // Close modal immediately
    setShowThemeModal(false);
    
    // Update local state and storage
    setIsDarkMode(pendingTheme);
    localStorage.setItem('theme', pendingTheme ? 'dark' : 'light');
    
    try {
      // Update database in background
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser);
          if (userData && userData.id) {
            const response = await authFetch(`${API_BASE_URL}/api/update-theme`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                user_id: userData.id,
                is_darkmode: pendingTheme ? 1 : 0
              })
            });
            
            if (!response.ok) {
              console.error('Failed to update theme in database');
            }
          }
        } catch (error) {
          console.error('Error parsing user data:', error);
        }
      }
    } catch (error) {
      console.error('Error updating theme:', error);
    } finally {
      setPendingTheme(null);
    }
  };

  const cancelThemeChange = () => {
    setShowThemeModal(false);
    setPendingTheme(null);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    // Clear all stored authentication data
    localStorage.removeItem('user');
    localStorage.clear();
    sessionStorage.clear();
    setShowLogoutModal(false);
    // Use replace to prevent back button navigation
    navigate('/login-admin', { replace: true });
    // Force page reload to clear any cached state
    window.location.href = '/login-admin';
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  // Persist view changes
  const handleSetView = (view) => {
    setCurrentView(view);
    try {
      localStorage.setItem('sa_current_view', view);
    } catch (e) {
      // ignore storage errors
    }
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest(`.${styles.profileSection}`)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  return (
    <div className={`${styles.systemApp} ${isDarkMode ? styles.darkMode : styles.lightMode}`}>
      {/* System Header */}
      <header className={styles.systemHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.systemLogo}>
            <img src="/BJMPRO-CAR.png" alt="BJMP Logo" className={styles.systemLogoImg} />
            <div className={styles.systemTitle}>
              <h1>MediCast: BJMP Health Monitoring System</h1>
              <p>Bureau of Jail Management and Penology - System Admin</p>
            </div>
          </div>
        </div>

        <div className={styles.headerRight}>
          <div className={styles.systemInfo}>
            <div className={styles.systemTime}>
              {currentTime.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
              })}
            </div>
            <div className={styles.systemUser}>System Admin Portal</div>
          </div>

          <div className={styles.profileSection}>
            <div className={styles.profileIcon} onClick={toggleDropdown}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            
            {isDropdownOpen && (
              <div className={styles.profileDropdown}>
                <div className={styles.dropdownHeader}>
                  <div className={styles.userInfo}>
                    <div className={styles.userRole}>
                      {userData?.user_type === 'unit_nurse' ? 'Unit Nurse' : 
                       userData?.user_type === 'chief_nurse' ? 'Chief Nurse' : 
                       userData?.user_type === 'warden' ? 'Warden' : 
                       userData?.user_type === 'admin' ? 'System Admin' : 
                       userData?.user_type === 'jail_officer' ? 'Jail Officer' : 'User'}
                    </div>
                    <div className={styles.userName}>
                      {userData ? 
                        `${userData.last_name ? userData.last_name.charAt(0).toUpperCase() + userData.last_name.slice(1).toLowerCase() : ''}, ${userData.first_name ? userData.first_name.charAt(0).toUpperCase() + userData.first_name.slice(1).toLowerCase() : ''} ${userData.middle_name ? userData.middle_name.charAt(0).toUpperCase() + userData.middle_name.slice(1).toLowerCase() : ''}`.trim() 
                        : 'User Name'}
                    </div>
                  </div>
                </div>
                <div className={styles.dropdownDivider}></div>
                <button className={styles.dropdownItem} onClick={() => toggleDarkMode(!isDarkMode)}>
                  {isDarkMode ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5M17.6859 17.69L18.5 18.5M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor"/>
                    </svg>
                  )}
                  {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                </button>
                <button className={styles.dropdownItem} onClick={() => setShowChangePasswordModal(true)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Change Password
                </button>
                <button className={styles.dropdownItem} onClick={handleLogout}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="16,17 21,12 16,7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Main Dashboard Container */}
      <div className={styles.dashboardContainer}>
        {/* Sidebar */}
        <nav className={styles.sidebar}>
          {/* Security & Audit moved to top; Security Settings removed */}
          <div className={styles.sidebarSection}>
            <div className={styles.sidebarTitle}>Security & Audit</div>
            <ul className={styles.sidebarMenu}>
              <li className={styles.sidebarItem}>
                <button 
                  className={`${styles.sidebarLink} ${currentView === 'auditlogs' ? styles.active : ''}`}
                  onClick={() => handleSetView('auditlogs')}
                >
                  <svg className={styles.sidebarIcon} width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M21 12c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1H3c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h18z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 12v7a1 1 0 01-1 1H5a1 1 0 01-1-1v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Audit Logs
                </button>
              </li>
            </ul>
          </div>

          <div className={styles.sidebarSection}>
            <div className={styles.sidebarTitle}>User Management</div>
            <ul className={styles.sidebarMenu}>
              <li className={styles.sidebarItem}>
                <button 
                  className={`${styles.sidebarLink} ${currentView === 'adduser' ? styles.active : ''}`}
                  onClick={() => handleSetView('adduser')}
                >
                  <svg className={styles.sidebarIcon} width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Add Users
                </button>
              </li>
              <li className={styles.sidebarItem}>
                <button 
                  className={`${styles.sidebarLink} ${currentView === 'resetpassword' ? styles.active : ''}`}
                  onClick={() => handleSetView('resetpassword')}
                >
                  <svg className={styles.sidebarIcon} width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Edit Users
                </button>
              </li>
            </ul>
          </div>

          <div className={styles.sidebarSection}>
            <div className={styles.sidebarTitle}>Cell Management</div>
            <ul className={styles.sidebarMenu}>
              <li className={styles.sidebarItem}>
                <button 
                  className={`${styles.sidebarLink} ${currentView === 'addcell' ? styles.active : ''}`}
                  onClick={() => handleSetView('addcell')}
                >
                  <svg className={styles.sidebarIcon} width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="12" y1="8" x2="12" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="8" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Add Cell
                </button>
              </li>
              <li className={styles.sidebarItem}>
                <button 
                  className={`${styles.sidebarLink} ${currentView === 'editcell' ? styles.active : ''}`}
                  onClick={() => handleSetView('editcell')}
                >
                  <svg className={styles.sidebarIcon} width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Edit Cell
                </button>
              </li>
            </ul>
          </div>
        </nav>

        {/* Main Content */}
        <main className={styles.mainContent}>
          {/* Content Header */}
          <div className={styles.contentHeader}>
            <div className={styles.headerContent}>
              <div className={styles.headerText}>
                <h1 className={styles.pageTitle}>
                  {currentView === 'overview' && 'System Admin Dashboard'}
                  {currentView === 'adduser' && 'User Management'}
                  {currentView === 'resetpassword' && 'Edit Users'}
                  {currentView === 'addcell' && 'Add Cell'}
                  {currentView === 'editcell' && 'Edit Cell'}
                  {currentView === 'analytics' && 'Analytics'}
                  {currentView === 'auditlogs' && 'Audit Logs'}
                </h1>
                <p className={styles.pageSubtitle}>
                  {currentView === 'overview' && 'System administration and management overview'}
                  {currentView === 'adduser' && 'Add and manage system users'}
                  {currentView === 'resetpassword' && 'Edit and manage user accounts'}
                  {currentView === 'addcell' && 'Add new cells to the facility'}
                  {currentView === 'editcell' && 'Edit existing cell information'}
                  {currentView === 'analytics' && 'System analytics and reporting'}
                  {currentView === 'auditlogs' && 'Track and monitor user login activity'}
                </p>
              </div>
            </div>
          </div>

          {/* Dynamic Content Area */}
          <div className={styles.contentArea}>
            {currentView === 'overview' && (
              <div className={styles.overviewContent}>
                <p style={{ color: '#94a3b8', textAlign: 'center', padding: '2rem' }}>
                  Dashboard overview content will be displayed here.
                </p>
              </div>
            )}
            
            {currentView === 'adduser' && (
              <SaAdduser 
                isDarkMode={isDarkMode}
                onSuccess={(message) => {
                  setSuccessMessage(message);
                  setShowSuccessModal(true);
                }}
                onError={(message) => {
                  setErrorModalMessage(message);
                  setShowErrorModal(true);
                }}
              />
            )}
            
            {currentView === 'resetpassword' && (
              <SaResetUserPassword isDarkMode={isDarkMode} />
            )}
            
            {currentView === 'addcell' && (
              <SaAddCell 
                isDarkMode={isDarkMode}
                onSuccess={(message) => {
                  setCellSuccessMessage(message);
                  setShowCellSuccessModal(true);
                }}
                onError={(message) => {
                  setCellErrorMessage(message);
                  setShowCellErrorModal(true);
                }}
              />
            )}
            
            {currentView === 'editcell' && (
              <SaEditCell isDarkMode={isDarkMode} />
            )}
            
            {currentView === 'analytics' && (
              <div className={styles.analyticsContent}>
                <p style={{ color: '#94a3b8', textAlign: 'center', padding: '2rem' }}>
                  Analytics content will be displayed here.
                </p>
              </div>
            )}
            
            {currentView === 'auditlogs' && (
              <SaAuditLogin isDarkMode={isDarkMode} />
            )}
          </div>
        </main>
      </div>

      {/* Success Modal */}
      {showSuccessModal && ReactDOM.createPortal(
        <div className={`${styles.modalOverlay} ${!isDarkMode ? 'lightMode' : ''}`} onClick={() => setShowSuccessModal(false)}>
          <div className={styles.successModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.successIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>User Created Successfully!</h3>
            <p>{successMessage}</p>
            <button className={styles.successBtn} onClick={() => setShowSuccessModal(false)}>
              OK
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Error Modal */}
      {showErrorModal && ReactDOM.createPortal(
        <div className={`${styles.modalOverlay} ${!isDarkMode ? 'lightMode' : ''}`} onClick={() => setShowErrorModal(false)}>
          <div className={styles.errorModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.errorIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Error Creating User</h3>
            <p>{errorModalMessage}</p>
            <button className={styles.errorBtn} onClick={() => setShowErrorModal(false)}>
              Close
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Cell Success Modal */}
      {showCellSuccessModal && ReactDOM.createPortal(
        <div className={`${styles.modalOverlay} ${!isDarkMode ? 'lightMode' : ''}`} onClick={() => setShowCellSuccessModal(false)}>
          <div className={styles.successModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.successIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Cell Added Successfully!</h3>
            <p>{cellSuccessMessage}</p>
            <button className={styles.successBtn} onClick={() => setShowCellSuccessModal(false)}>
              OK
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Cell Error Modal */}
      {showCellErrorModal && ReactDOM.createPortal(
        <div className={`${styles.modalOverlay} ${!isDarkMode ? 'lightMode' : ''}`} onClick={() => setShowCellErrorModal(false)}>
          <div className={styles.errorModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.errorIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Error Adding Cell</h3>
            <p>{cellErrorMessage}</p>
            <button className={styles.errorBtn} onClick={() => setShowCellErrorModal(false)}>
              Close
            </button>
          </div>
        </div>,
        document.body
      )}

      {/* Change Password Modal */}
      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
        userData={JSON.parse(localStorage.getItem('user'))}
        onSuccess={(msg) => {
          setSuccessMessage(msg);
          setShowSuccessModal(true);
        }}
        onError={(msg) => {
          setErrorModalMessage(msg);
          setShowErrorModal(true);
        }}
      />

      {/* Theme Change Confirmation Modal */}
      {showThemeModal && ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={cancelThemeChange}>
          <div className={styles.themeModal} onClick={(e) => e.stopPropagation()} style={{borderColor: '#f59e0b', background: isDarkMode ? '#1e293b' : 'white'}}>
            <div className={styles.themeIcon} style={{background: 'rgba(245, 158, 11, 0.1)'}}>
              {pendingTheme ? (
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                </svg>
              ) : (
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5M17.6859 17.69L18.5 18.5M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
            <h3 style={{color: '#f59e0b', textAlign: 'center'}}>Change Theme</h3>
            <p style={{textAlign: 'center', color: isDarkMode ? '#cbd5e1' : '#475569'}}>Are you sure you want to switch to <strong>{pendingTheme ? 'Dark' : 'Light'} Mode</strong>?</p>
            <div style={{display: 'flex', gap: '0.75rem', width: '100%'}}>
              <button className={styles.cancelBtn} onClick={cancelThemeChange}>
                Cancel
              </button>
              <button className={styles.themeBtn} onClick={confirmThemeChange}>
                Confirm
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutModal && ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={cancelLogout}>
          <div className={styles.themeModal} onClick={(e) => e.stopPropagation()} style={{ borderColor: '#ef4444' }}>
            <div className={styles.themeIcon} style={{ background: 'rgba(239, 68, 68, 0.1)', borderColor: 'rgba(239, 68, 68, 0.3)', color: '#ef4444' }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="16,17 21,12 16,7" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="21" y1="12" x2="9" y2="12" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 style={{ color: '#ef4444' }}>Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button className={styles.cancelBtn} onClick={cancelLogout}>Cancel</button>
              <button className={styles.themeBtn} onClick={confirmLogout} style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' }}>Logout</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

export default SaHomepage;
